import {create} from 'zustand';

import {
  type NotebookQuotaAction,
  type NotebookQuotaRefusal,
  notebookQuotaRefusalFromError,
} from '../../util/notebookQuota';

/**
 * The one open quota modal. Notebook create, duplicate, and launch fire from
 * drawers, tables, panel settings, and the runtime page; they all report a
 * refusal here and NotebookQuotaModal, mounted once in App, shows it.
 */
type NotebookQuotaModalState = {
  refusal: NotebookQuotaRefusal | null;
  show(refusal: NotebookQuotaRefusal): void;
  dismiss(): void;
};

export const useNotebookQuotaModalStore = create<NotebookQuotaModalState>(
  set => ({
    refusal: null,
    show: refusal => set({refusal}),
    dismiss: () => set({refusal: null}),
  })
);

/**
 * Opens the modal when the error is a quota refusal and reports whether it
 * was one, so the caller can skip its generic failure toast.
 */
export function showNotebookQuotaModalForError(
  error: unknown,
  action: NotebookQuotaAction = 'create'
): boolean {
  const refusal = notebookQuotaRefusalFromError(error, action);
  if (refusal == null) {
    return false;
  }
  useNotebookQuotaModalStore.getState().show(refusal);
  return true;
}
